/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

(function (exports) {

    // Put functions into Modal
    function Modal() {}

    Modal.prototype.openModal = function (targetClass) {

        // If a modal form has any errors or content, clear all
        $(targetClass + ' *').filter('.input-error').each(function () {
            $(this).removeClass('input-error');
        });
        $(targetClass + ' *').filter('.help-block').each(function () {
            $(this).text('');
        });

        // Open modal
        $('body').addClass('fix-position');
        $(targetClass).addClass('modal__overlay--displayed');

        setTimeout(function () {
            $(targetClass).addClass('modal__overlay--active');
        }, 0);
    };

    Modal.prototype.closeModal = function () {

        $('.modal__overlay').removeClass('modal__overlay--active');

        setTimeout(function () {

            $('.modal__overlay').removeClass('modal__overlay--displayed');
            $('body').removeClass('fix-position');
        }, 250);
    };

    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return Modal.prototype;
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = Modal.prototype;
    } else {
        exports.Modal = Modal.prototype;
    }
})(undefined);

$(document).ready(function () {

    $(document).on('click', '.close-site-modal', function (e) {
        e.preventDefault();

        $('.modal__overlay').removeClass('modal__overlay--active');

        setTimeout(function () {

            $('.modal__overlay').removeClass('modal__overlay--displayed');
            $('body').removeClass('fix-position');
        }, 250);
    });
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

(function (exports) {

    // Put functions into DataTableInit
    function DataTableInit() {}

    DataTableInit.prototype.construct = function (datatable) {
        var hasCheckboxes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


        if ($('.data-table')) {

            // Get selectbox over table and sort table base off value
            $('.mobile-sort').change(function () {

                // Get selected index
                var index;
                if (hasCheckboxes) {
                    // First 2 options don't select checkbox column ASC and DESC
                    index = $(this)[0].selectedIndex + 2;
                } else {
                    index = $(this)[0].selectedIndex;
                }
                var order = 'desc';
                var colIndex = 0;

                // If selected index is even then ASC else stay as DESC
                if (index % 2 == 0) {
                    order = 'asc';
                }

                // Make so colIndex is calculated based off index
                colIndex = Math.floor(index / 2);

                // Re-order table
                datatable.order([[colIndex, order]]).draw();
            });

            datatable.on('processing.dt', function (e, settings, processing) {
                if (processing) {
                    $('.data-table').css('opacity', '0.2');
                    $('.data-table').css('transition', '0.2s ease-out');
                } else {
                    $('.data-table').css('opacity', '1');
                    $('.data-table').css('transition', '0.2s ease-in');
                }
            });
        }
    };

    // table rows redirect on click
    DataTableInit.prototype.makeRowsClickable = function () {

        $('td').click(function (event) {
            //event.stopPropagation();

            if (!$(this).hasClass('checkbox-td')) {

                var dataHref = $(this).parent().attr('data-href');

                if (dataHref) {
                    window.location.href = dataHref;
                }
            }
        });
    };

    DataTableInit.prototype.addDropdownArrowsSelectbox = function () {

        var sortContainer = $('.dataTables_length label select');
        sortContainer.wrap('<div class="dt-select-with-dropdown-arrow"></div>');
    };

    DataTableInit.prototype.handlePaginationState = function () {
        // If only page then don't display next/prev
        if ($('.paginate_button').length <= 3) {

            $('.paginate_button.previous').addClass('pagination-disabled');
            $('.paginate_button.next').addClass('pagination-disabled');
        } else if ($('.current').attr('data-dt-idx') == 1) {

            $('.paginate_button.previous').addClass('pagination-disabled');
        } else if ($('.current').attr('data-dt-idx') == $('.dataTables_paginate span').children().length) {

            $('.paginate_button.next').addClass('pagination-disabled');
        }
    };

    DataTableInit.prototype.addDropdownArrows = function () {
        // Add ability to put dropdown arrows next to th text
        $('th').each(function () {
            var text = $(this).text();
            $(this).text("");
            $(this).html('<div class="sort-arrow-container">' + text + '</div>');
        });
    };

    DataTableInit.prototype.addSearchCross = function () {
        $('.dataTables_filter input').wrap('<span class="search-container"></span>');
        $('.search-container').append('<div class="search-cross"></div>');

        // Add cross to search field
        $('.dataTables_filter input').keyup(function () {
            if ($('.dataTables_filter input').val().length > 0) {
                $('.search-cross').addClass('search-cross--active');
            } else {
                $('.search-cross').removeClass('search-cross--active');
            }
        });

        // When cross clicked remove text + cross and reset datatable
        $('.search-cross').click(function () {
            $('.search-container input').val('');
            location.reload();
        });
    };

    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return DataTableInit.prototype;
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = DataTableInit.prototype;
    } else {
        exports.DataTableInit = DataTableInit.prototype;
    }
})(undefined);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(0);

__webpack_require__(3);

__webpack_require__(4);

__webpack_require__(5);

__webpack_require__(6);

__webpack_require__(1);

__webpack_require__(7);

__webpack_require__(8);

__webpack_require__(9);

__webpack_require__(10);

__webpack_require__(11);

__webpack_require__(12);

__webpack_require__(13);

__webpack_require__(14);

__webpack_require__(15);

__webpack_require__(16);

__webpack_require__(17);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {

    $('.switch-guest-view').click(function (e) {
        e.preventDefault();

        var showGrid = true;

        if ($('#guests-grid-view').is(":visible")) {
            showGrid = false;
        }

        $('.guest-view').hide();

        if (showGrid) {
            $('#guests-grid-view').show();
            $('.switch-guest-view').text('Table View');
        } else {
            $('#guests-table-view').show();
            $('.switch-guest-view').text('Card View');
        }
    });

    $('.go-back-btn').click(function () {
        window.history.back();
    });

    var datatableSelectSelector = '.dataTables_length label select';
    var datatableSearchSelector = '.search-container input';

    $(document).on("change", datatableSearchSelector, function () {
        setLocationHash($(this).val(), 'qry');
    });

    $(document).on("change", datatableSelectSelector, function () {
        setLocationHash($(this).val(), 'limit');
    });

    function setLocationHash(val, varName) {

        var existingHash = document.location.hash;

        if (existingHash.includes("?")) {
            document.location.hash += "&" + varName + "=" + val;
        } else {
            document.location.hash = "?" + varName + "=" + val;
        }
    }

    // function setDatatablesSearch(val){
    //     $(datatableSearchSelector).val(val).trigger('click');
    // }

    // function setDatatablesSelect(val){
    //     $(datatableSelectSelector).val(val);
    // }

});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _modal = __webpack_require__(0);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {

	//check that user has added at least one guest before form submit
	$("#create-visit-form").submit(function (event) {

		var guestsLen = $('.guest').length;

		if (guestsLen < 1) {
			event.preventDefault();
			alert("Please add at least one guest.");
		}
	});

	var originalPassVals = {
		init: $('.pass-number-field').attr('data-color-init'),
		color: $('.pass-number-field').css('color')
	};

	$('select#visit-type').on('change', function () {
		if ($(this).val() == 2) {
			$('#couriers').show();
			$('.pass-number-field').attr('data-color-init', 'W').css('color', 'white');
		} else {
			$('#couriers').hide();
			$('.pass-number-field').attr('data-color-init', originalPassVals.init).css('color', originalPassVals.color);
		}
	});

	$('select#visit-type').trigger('change');

	//var guestCounter = ($('.guest').length + 1);
	var guestCounter = $('.guest').length;

	$('.add-guest').click(function (e) {
		e.preventDefault();

		addGuest();
	});

	function addGuest() {
		var html = createGuestHtml();
		$('.guests').append(html);

		//increment each time - even if one is removed ids wont overlap
		guestCounter++;
	}

	function createGuestHtml() {
		var html = '\n\t\t\t<div class="row guest" id="guest_' + getGuestCount() + '">\n\t\t\t\t\t\n\t\t\t\t<div class="item">\n\t\t\t\t\t<p class="heading">\n\t\t\t\t\t\tFirst Name<span class="required-field">&#42;</span>\n\t\t\t\t\t</p>\n\t\t\t\t\t\n\t\t\t\t</div>\n\n\t\t\t\t<div class="item">\n\t\t\t\t\t <input class="guest-first-name" name="guest[' + getGuestCount() + '][first_name]" value="" required>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="item">\n\t\t\t\t\t<p class="heading">\n\t\t\t\t\t\tSurname<span class="required-field">&#42;</span>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="item">\n\t\t\t\t\t <input class="guest-surname" name="guest[' + getGuestCount() + '][surname]" value="" required>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div class="item">\n\t\t\t\t\t<p class="heading">\n\t\t\t\t\t\tCompany\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="item">\n\t\t\t\t\t <input class="guest-company" name="guest[' + getGuestCount() + '][company]" value="">\n\t\t\t\t</div>\n\t\t\t\t\t\n\t\t\t\t<div class="item">\n\t\t\t\t\t<p class="heading">\n\t\t\t\t\tContact Number\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div class="item">\n\t\t\t\t\t <input class="guest-contact" name="guest[' + getGuestCount() + '][contact_number]" value="">\n\t\t\t\t</div>\t\t        \n\t\t\t    \n\t\t\t\t\n\t\t\t\t<div class="item">\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div class="item visit-user-links">\n\t\t\t\t\t<a href="" class="remove-guest">Remove Passenger</a>\n\t\t\t\t</div>\n\t\t\t\n\n\t\t\t\t<input class="guest-user-id" type="hidden" name="guest[' + getGuestCount() + '][user_id]" value="">\n\n\t\t\t</div>';
		return html;
	}

	//taken out for the moment - when the mobile app is used will bring it back in, at the moment the sign in method is hardcoded as group sign in  - in VisitRepository
	// <div class="item">
	// 				<p class="heading">
	// 				Sign In method<span class="required-field">&#42;</span>
	// 				</p>
	// 			</div>

	// 			<div class="item">` + getSignInOptionsHtml() + `
	// 			</div>	

	function getSignInOptionsHtml() {
		var html = '<div class="select-with-dropdown"><select class="form-control" name="guest[' + getGuestCount() + '][sign_in_method]" required>';
		//get the options
		html += $('#sign-in-method').html();
		html += '</select></div>';
		return html;
	}

	//get the correct guest row and set hidden field with val and open modal
	$(document).on('click', '.link-to-user', function (e) {
		e.preventDefault();

		_modal2.default.openModal('.modal-link-guest');

		setGuestBoxId($(this));
	});

	$(document).on('click', '.remove-guest', function (e) {
		e.preventDefault();

		var parent = getParent($(this));

		//remove parent - check if existing guest - set in deleted id array
		var hiddenIdEl = parent.find('.guest-id');

		//check if this has id ( i.e. exists in database )
		if (hiddenIdEl.length) {
			//pass id through to server

			var guestId = hiddenIdEl.val();

			//add offer id to hidden fields
			var inputHtml = '<input type="hidden" name="deletedGuests[]" value="' + guestId + '">';
			$('.deletedGuests').append(inputHtml);
		}
		parent.remove();
	});

	//confirm delete
	$(document).on('click', '.delete-visit', function (e) {
		e.preventDefault();

		_modal2.default.openModal('.modal-remove-visit');
	});

	function getParent(self) {
		return self.parent('.item').parent('.guest');
	}

	function getGuestCount() {
		return guestCounter;
	}

	function fillGuestData(response, isUser) {
		var parentGuestBox = getParentGuestBox();

		parentGuestBox.find('.guest-first-name').val(response.first_name);
		parentGuestBox.find('.guest-surname').val(response.surname);
		parentGuestBox.find('.guest-company').val(response.company);
		parentGuestBox.find('.guest-email').val(response.email);
		parentGuestBox.find('.guest-contact').val(response.contact_number);

		//if theyve used a user to popualate details - dont want to use VisitGuest id
		if (isUser) {
			parentGuestBox.find('.guest-user-id').val(response.id);
		}
	}

	$(".guest-select").change(function () {

		var optionSelected = $('option:selected', this);
		var guestId = optionSelected.val();

		if (optionSelected.hasClass('guest-option')) {
			//is user - get details
			getVisitGuestDetails(guestId);
		} else {
			//is user - get details
			getUserDetails(guestId);
		}
	});

	function getVisitGuestDetails(guestId) {
		$.ajax({
			url: window.site.url + '/api/guest-details',
			method: 'GET',
			data: {
				id: guestId
			},
			success: function success(response) {
				//response is html
				fillGuestData(response, false);
			}
		});
	}

	function getUserDetails(userId) {
		$.ajax({
			url: window.site.url + '/api/user',
			method: 'GET',
			data: {
				id: userId
			},
			success: function success(response) {
				//response is html
				fillGuestData(response, true);
			}
		});
	}

	function getParentGuestBox() {
		return $("#" + $('#guestBoxId').val());
	}

	function setGuestBoxId(self) {
		var parentId = getParent(self).attr('id');
		$('#guestBoxId').val(parentId);
	}

	$(document).on('click', '.create-user', function (e) {
		e.preventDefault();

		_modal2.default.openModal('.modal-create-user');
		var self = $(this);
		setGuestBoxId(self);

		//set create user modal values if set
		setModalInputValues(self);
	});

	function setModalInputValues(self) {
		var parent = getParent(self);
		var firstName = parent.find('.guest-first-name').val();
		var surname = parent.find('.guest-surname').val();
		var email = parent.find('.guest-email').val();
		var company = parent.find('.guest-company').val();

		$('#user-form-first-name').val(firstName);
		$('#user-form-surname').val(surname);
		$('#user-form-email').val(email);
		$('#user-form-company').val(company);
	}

	$(document).on('click', '#create-user-button', function (e) {
		e.preventDefault();

		//get form fields

		var data = {
			email: $('#user-form-email').val(),
			first_name: $('#user-form-first-name').val(),
			surname: $('#user-form-surname').val(),
			company: 'fk',
			company_id: $('.user-modal-select').val(),
			password: $('#user-form-password').val(),
			contact_number: $('#user-form-contact-number').val(),
			password_confirmation: $('#user-form-password-confirm').val(),
			_token: window.site.token
		};

		$.ajax({
			url: window.site.url + '/user/create/ajax',
			method: 'POST',
			data: data,
			success: function success(response) {
				//response is html
				_modal2.default.closeModal();
				fillGuestData(response, true);
			},
			error: function error(jqXHR, textStatus, errorThrown) {
				var responseText = $.parseJSON(jqXHR.responseText);
				var html = createErrorMessage(responseText);
				$('.user-create-errors').html(html);
			}
		});
	});

	function createErrorMessage(response) {
		$.each(response, function (index, value) {
			$('input[name="' + index + '"]').parent().addClass('input-error');
			if (index == 'password') {
				$('input[name="password_confirmation"]').parent().addClass('input-error');
				$('input[name="password_confirmation"]').next().closest('span').text(value[0]);
			}
			$('input[name="' + index + '"]').next().closest('span').text(value[0]);
		});
	}

	$('.create-visit-btn').click(function () {
		$('#create-visit-form').submit();
	});

	$('.filter-visits-btn').click(function () {
		_modal2.default.openModal('.filter-modal');
	});

	$('.link-to-user-select').change(function () {
		_modal2.default.closeModal();
	});
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _modal = __webpack_require__(0);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {

				$(document).on('click', '.merge-users', function (e) {
								e.preventDefault();

								_modal2.default.openModal('.modal-merge-user');
				});

				$(document).on('click', '.delete-user-btn', function (e) {
								e.preventDefault();

								_modal2.default.openModal('.modal-delete-user');
				});

				//$(document).on('click', '#select-user-link-button', function(e) {
				$(".user-select").change(function (e) {
								e.preventDefault();

								var userId = $('option:selected', ".user-select").val();

								$.ajax({
												url: window.site.url + '/api/user',
												method: 'GET',
												data: {
																id: userId
												},
												success: function success(response) {
																console.log(response);
																setUserInputs(response);
																$("#userLinkModal .close-modal").click();
												}
								});
				});

				function setUserInputs(response) {
								$('#guest-first-name').val(response.first_name + " " + response.surname);
								$('#guest-surname').val(response.first_name + " " + response.surname);
								$('#guest-email').val(response.email);
								$('#guest-company').val(response.company);
								$('#user-id').val(response.id);
				}

				$(document).on('click', '.end-visit', function (e) {
								e.preventDefault();

								_modal2.default.openModal('.modal-end-visit');

								$('.end-visit-confirm').attr('href', $(this).attr('href'));
				});

				$(document).on('click', '.log-user-out', function (e) {
								e.preventDefault();

								_modal2.default.openModal('.modal-log-user-out');

								$('.log-user-out-confirm').attr('href', $(this).attr('href'));
				});

				// Add filename to upload field
				$('.input-upload').change(function () {
								var filename = $('.input-upload').val().split('\\').pop();
								$('.input-placeholder-text').text(filename);
				});

				$('.profile-image').click(function () {
								// var filename = $('.input-upload1').val().split('\\').pop();
								// $('.input-placeholder-text').text(filename);
								$('.input-upload').trigger('click');
				});

				$('.guest-select').wrap('<div class="modal-select-with-dropdown-arrow"></div>');

				$('.filter-guests-btn').click(function () {
								_modal2.default.openModal('.filter-modal');
				});
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {

    $('.mob-burger').click(function () {

        if ($(this).hasClass('mob-burger--active')) {

            // Make transition
            $('.nav').removeClass('nav-mob--active');
            $(this).removeClass('mob-burger--active');

            $('body').removeClass('fix-position');
        } else {

            // Add fixed to body
            $('body').addClass('fix-position');
            $(this).addClass('mob-burger--active');

            // Add Z-index
            $('.nav').addClass('nav-mob--active');
        }
    });
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datatable = __webpack_require__(1);

var _datatable2 = _interopRequireDefault(_datatable);

var _modal = __webpack_require__(0);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {
    if ($('.visits-data-table').length) {
        var isFilterEmpty = function isFilterEmpty() {
            var isEmpty = false;
            var checkboxesTicked = [];

            $('.site-modal input:checked').each(function () {
                checkboxesTicked.push($(this).attr('value'));
            });

            // If dates and checkboxes all empty then true
            if ($('#filterDate').val() == '' && $('#startDateTime').val() == '' && $('#endDateTime').val() == '' && checkboxesTicked.length == 0) {
                isEmpty = true;
            }

            return isEmpty;
        };

        var selected;

        var dataTable = $('.visits-data-table').DataTable({
            dom: 'lfrtipB',
            "lengthMenu": [[10, 25, 50, 100, 1000], [10, 25, 50, 100, 1000]],
            buttons: [{
                extend: 'csv',
                text: 'Export to CSV',
                exportOptions: {
                    modifier: {
                        page: 'all'
                    }
                }

            }],
            processing: true,
            serverSide: true,
            language: {
                sLengthMenu: "Show _MENU_",
                emptyTable: "No Visits available"
            },
            ajax: {
                url: window.site.visitsTableData,
                data: function data(d) {
                    d.company = selected;
                    d.filterDate = $('#filterDate option:selected').val();
                    d.startDateTime = $('#startDateTime').val();
                    d.endDateTime = $('#endDateTime').val();
                }
            },
            columns: [{ data: 'action', name: 'action', orderable: false, searchable: false, className: 'select-checkbox checkbox-td', targets: 0 }, { data: 'id', name: 'visits.id', visible: false }, { data: 'guests', name: 'visit_guest.first_name' }, // Need to hook onto something that actually exists but gets overwritten using filterColumn in visitRepo (known bug in current laravel datatables implementation)
            { data: 'company_name', name: 'company.company_name' }, { data: 'company_employee', name: 'visits.company_employee' }, { data: 'visitor_pass_number', name: 'visits.visitor_pass_number' }, { data: 'vehicle_reg', name: 'visits.vehicle_reg' }, { data: 'visit_date', name: 'visits.visit_date' }, { data: 'leave_date_time', name: 'visits.leave_date_time' }, { data: 'courier_name', name: 'couriers.name', visible: false }],
            "fnDrawCallback": function fnDrawCallback() {
                _datatable2.default.handlePaginationState();
                _datatable2.default.addDropdownArrows();
                _datatable2.default.makeRowsClickable();
                _datatable2.default.addDropdownArrowsSelectbox();
            },
            "fnInitComplete": function fnInitComplete() {
                _datatable2.default.addSearchCross();
                _datatable2.default.makeRowsClickable();
            },
            'createdRow': function createdRow(row, data, dataIndex) {
                $(row).attr('data-href', window.site.url + '/visit/' + data.id);
                $(row).attr('data-visit-id', data.id);
            },
            select: {
                style: 'multi',
                selector: 'td:first-child'
            }
        });

        _datatable2.default.construct(dataTable, true);

        dataTable.order([7, 'desc']).draw();

        // Filter
        $('.filter-btn').click(function (e) {
            e.preventDefault();

            selected = [];

            $('.site-modal input:checked').each(function () {
                selected.push($(this).attr('value'));
            });

            dataTable.draw();
            _modal2.default.closeModal();
            if (isFilterEmpty()) {
                $('.download-btn').show();
            } else {
                $('.download-btn').hide();
            }
        });

        $('.clear-filter-btn').click(function (e) {
            e.preventDefault();

            $('input:checkbox').prop('checked', false);
            $('#filterDate').val('');
            $('#startDateTime').val('');
            $('#endDateTime').val('');
            dataTable.draw();
            _modal2.default.closeModal();
            $('.download-btn').show();
        });

        $('#filterDate').change(function () {
            $('#endDateTime').val('');
            $('#startDateTime').val('');
        });
    }
});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datatable = __webpack_require__(1);

var _datatable2 = _interopRequireDefault(_datatable);

var _modal = __webpack_require__(0);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {
    if ($('.today-visits-data-table').length) {
        var isFilterEmpty = function isFilterEmpty() {
            var isEmpty = false;
            var checkboxesTicked = [];

            $('.site-modal input:checked').each(function () {
                checkboxesTicked.push($(this).attr('value'));
            });

            // If dates and checkboxes all empty then true
            if (checkboxesTicked.length == 0) {
                isEmpty = true;
            }

            return isEmpty;
        };

        var selected;

        var dataTable = $('.today-visits-data-table').DataTable({
            dom: 'lfrtipB',
            "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
            buttons: [{
                extend: 'csv',
                text: 'Export to CSV',
                exportOptions: {
                    modifier: {
                        page: 'all'
                    }
                }

            }],
            processing: true,
            serverSide: true,
            language: {
                sLengthMenu: "Show _MENU_",
                emptyTable: "No Visits today"
            },
            ajax: {
                url: window.site.todaysVisitsTableData,
                data: function data(d) {
                    d.company = selected;
                }
            },
            columns: [{ data: 'action', name: 'action', orderable: false, searchable: false, className: 'select-checkbox checkbox-td', targets: 0 }, { data: 'id', name: 'visits.id', visible: false }, { data: 'guests', name: 'visit_guest.first_name' }, // Need to hook onto something that actually exists but gets overwritten using filterColumn in visitRepo (known bug in current laravel datatables implementation)
            { data: 'company_name', name: 'company.company_name' }, { data: 'company_employee', name: 'visits.company_employee' }, { data: 'visitor_pass_number', name: 'visits.visitor_pass_number' }, { data: 'vehicle_reg', name: 'visits.vehicle_reg' }, { data: 'visit_date', name: 'visits.visit_date' }, { data: 'leave_date_time', name: 'visits.leave_date_time' }, { data: 'origin_company', name: 'visit_guest.company', visible: false }, { data: 'courier_name', name: 'couriers.name', visible: false }],
            "fnDrawCallback": function fnDrawCallback() {
                _datatable2.default.handlePaginationState();
                _datatable2.default.addDropdownArrows();
                _datatable2.default.makeRowsClickable();
                _datatable2.default.addDropdownArrowsSelectbox();
            },
            "fnInitComplete": function fnInitComplete() {
                _datatable2.default.addSearchCross();
                _datatable2.default.makeRowsClickable();
            },
            'createdRow': function createdRow(row, data, dataIndex) {
                $(row).attr('data-href', window.site.url + '/visit/' + data.id);
                $(row).attr('data-visit-id', data.id);
            },
            select: {
                style: 'multi',
                selector: 'td:first-child'
            }
        });

        _datatable2.default.construct(dataTable, true);

        dataTable.order([7, 'desc']).draw();

        // Filter
        $('.filter-btn').click(function (e) {
            e.preventDefault();

            selected = [];

            $('.site-modal input:checked').each(function () {
                selected.push($(this).attr('value'));
            });

            dataTable.draw();
            _modal2.default.closeModal();
            if (isFilterEmpty()) {
                $('.download-btn').show();
            } else {
                $('.download-btn').hide();
            }
        });

        $('.clear-filter-btn').click(function (e) {
            e.preventDefault();

            $('input:checkbox').prop('checked', false);
            dataTable.draw();
            _modal2.default.closeModal();
            $('.download-btn').show();
        });
    }
});

$('[data-trigger-csv]').click(function (e) {
    e.preventDefault();
    $('.dt-button.buttons-csv.buttons-html5').trigger('click');
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datatable = __webpack_require__(1);

var _datatable2 = _interopRequireDefault(_datatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {
    if ($('.settings-user-data-table').length) {

        var dataTable = $('.settings-user-data-table').DataTable({
            processing: true,
            serverSide: true,
            language: {
                sLengthMenu: "Show _MENU_"
            },
            ajax: window.site.settingsTableData,
            columns: [{ data: 'id', name: 'users.id' }, { data: 'name', name: 'users.first_name' }, { data: 'email', name: 'users.email' }, { data: 'role_name', name: 'roles.role_name' }],
            "fnDrawCallback": function fnDrawCallback() {
                _datatable2.default.handlePaginationState();
                _datatable2.default.addDropdownArrows();
                _datatable2.default.makeRowsClickable();
                _datatable2.default.addDropdownArrowsSelectbox();
            },
            "fnInitComplete": function fnInitComplete() {
                _datatable2.default.addSearchCross();
                _datatable2.default.makeRowsClickable();
            },
            'createdRow': function createdRow(row, data, dataIndex) {
                $(row).attr('data-href', window.site.url + '/user/' + data.id + '/edit');
                $(row).attr('data-visit-id', data.id);
            }
        });

        _datatable2.default.construct(dataTable);

        dataTable.order([[0, 'desc'], [1, 'desc']]).draw();
    }
});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datatable = __webpack_require__(1);

var _datatable2 = _interopRequireDefault(_datatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {
    if ($('.guests-data-table').length) {

        var dataTable = $('.guests-data-table').DataTable({
            processing: true,
            serverSide: true,
            language: {
                sLengthMenu: "Show _MENU_",
                emptyTable: "No Guests available"
            },
            ajax: window.site.guestsTableData,
            columns: [
            // { data: 'guests', name: 'visit_guest.first_name' },
            // { data: 'company', name: 'visit_guest.company'},
            // { data: 'visitsCount', name: 'visit_guest.first_name' },
            // { data: 'lastVisitDate', name: 'visit_guest.first_name' },
            // { data: 'current', name: 'visits.current' },
            // { data: 'type', name: 'visit_guest.first_name' },
            { data: 'guests', name: 'guests' }, { data: 'company', name: 'company' }, { data: 'visitsCount', name: 'visitsCount' }, { data: 'lastVisitDate', name: 'lastVisitDate' }, { data: 'current', name: 'current' }, { data: 'type', name: 'type' }],
            "fnDrawCallback": function fnDrawCallback() {
                _datatable2.default.handlePaginationState();
                _datatable2.default.addDropdownArrows();
                _datatable2.default.makeRowsClickable();
                _datatable2.default.addDropdownArrowsSelectbox();
            },
            "fnInitComplete": function fnInitComplete() {
                _datatable2.default.addSearchCross();
                _datatable2.default.makeRowsClickable();
            },
            'createdRow': function createdRow(row, data, dataIndex) {
                if (data.type == 'User') {
                    $(row).attr('data-href', window.site.url + '/guest/user/single/' + data.id);
                } else {
                    $(row).attr('data-href', window.site.url + '/guest/single/' + data.id);
                }
            }
        });

        _datatable2.default.construct(dataTable);

        dataTable.order([[3, 'desc']]).draw();
    }
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datatable = __webpack_require__(1);

var _datatable2 = _interopRequireDefault(_datatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {
    if ($('.onsitenow-data-table').length) {

        var dataTable = $('.onsitenow-data-table').DataTable({
            processing: true,
            serverSide: true,
            language: {
                sLengthMenu: "Show _MENU_",
                emptyTable: "No Guests currently on site"
            },
            ajax: window.site.onsitenowTableData,
            columns: [{ data: 'visitId', name: 'visits.id', orderable: true },
            // has to filter on visit_guest.first_name which is filtered in repo, cannot filter on alias
            { data: 'guests', name: 'visit_guest.first_name' }, { data: 'host_name', name: 'company.company_name' }, { data: 'company', name: 'visit_guest.company' }, { data: 'lastVisitDate', name: 'visits.visit_date' }, { data: 'vehicle_reg', name: 'visits.vehicle_reg' }, { data: 'visitor_pass_number', name: 'visits.visitor_pass_number' }],
            "fnDrawCallback": function fnDrawCallback() {
                _datatable2.default.handlePaginationState();
                _datatable2.default.addDropdownArrows();
                _datatable2.default.makeRowsClickable();
                _datatable2.default.addDropdownArrowsSelectbox();
            },
            "fnInitComplete": function fnInitComplete() {
                _datatable2.default.addSearchCross();
                _datatable2.default.makeRowsClickable();
            },
            'createdRow': function createdRow(row, data, dataIndex) {
                if (data.type == 'User') {
                    $(row).attr('data-href', window.site.url + '/guest/user/single/' + data.userId);
                } else {
                    $(row).attr('data-href', window.site.url + '/guest/single/' + data.visit_guestId);
                }
            }
        });

        _datatable2.default.construct(dataTable);

        dataTable.order([[4, 'desc']]).draw();
    }
});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datatable = __webpack_require__(1);

var _datatable2 = _interopRequireDefault(_datatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {
    if ($('.user-data-table').length) {

        var dataTable = $('.user-data-table').DataTable({
            processing: true,
            serverSide: true,
            language: {
                sLengthMenu: "Show _MENU_",
                emptyTable: "User currently has no visits"
            },
            ajax: window.site.userHistoryTableData,
            columns: [
            // { data: 'action', name: 'action', orderable: false, searchable: false, className: 'select-checkbox checkbox-td', targets: 0 },
            { data: 'id', name: 'visits.id' }, { data: 'company_name', name: 'company.company_name' }, { data: 'visit_date', name: 'visits.visit_date' }, { data: 'method_name', name: 'sign_in_method.method_name' }],
            "fnDrawCallback": function fnDrawCallback() {
                _datatable2.default.handlePaginationState();
                _datatable2.default.addDropdownArrows();
                _datatable2.default.makeRowsClickable();
                _datatable2.default.addDropdownArrowsSelectbox();
            },
            "fnInitComplete": function fnInitComplete() {
                _datatable2.default.addSearchCross();
                _datatable2.default.makeRowsClickable();
            },
            'createdRow': function createdRow(row, data, dataIndex) {
                $(row).attr('data-href', window.site.url + '/visit/' + data.id);
            }
        });

        _datatable2.default.construct(dataTable, true);

        dataTable.order([[3, 'desc']]).draw();
    }
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {

    if ($('.alert').length > 0) {

        $('.alert').show();
        setTimeout(function () {
            $('.alert').addClass('alert--active');
            $('.quick-add-visit-icon').addClass('quick-add-visit-icon--active');

            setTimeout(function () {
                $('.alert').removeClass('alert--active');
                $('.quick-add-visit-icon').removeClass('quick-add-visit-icon--active');
            }, 3500);
        }, 500);
    }
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _modal = __webpack_require__(0);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {

    //remove initial arrow
    $('th.select-checkbox').removeClass('sorting_desc');

    $('.bulk-action').change(function () {
        var actionVal = $(this).val();
        $('.bulk-action-text-info').html("");

        var route = '/visit/destroy/bulk';
        var signOut = false;
        var bulkActionText = 'Are you sure you want to delete these visits?';

        if (actionVal === 'sign-out') {
            route = '/visit/end/bulk';
            signOut = true;
            bulkActionText = 'Are you sure you want to sign out these visits?';
        }

        var ids = getCheckedVisitIds(signOut);

        _modal2.default.openModal('.bulk-action-modal');

        $('.bulk-action-text').html(bulkActionText);

        $('.bulk-action-modal .close-site-modal').click(function () {
            $('.bulk-action').val('null');
        });

        // If modal accepted close modal and fire request
        $('.bulk-action-accept').click(function () {
            //fire off api request

            if (ids.length > 0) {
                $(this).html('Working...');
                doAction(route, ids);
            }
        });
    });

    function getCheckedVisitIds(signOut) {

        var visitIds = [];
        var error = "";

        $("tr.selected").each(function () {

            if ($(this).attr('data-is-scheduled') === "1" && signOut) {

                error = "<p>One or more of the visits selected is scheduled so they will not be signed out</p>";
            } else {
                //add the visit id
                visitIds.push($(this).attr('data-visit-id'));
            }
        });

        if (error) {
            $('.bulk-action-text-info').html(error);
        }

        return visitIds;
    }

    function showAlert(endRoute) {
        $('.alert').show();
        setTimeout(function () {
            $('.alert').addClass('alert--active');
            $('.quick-add-visit-icon').addClass('quick-add-visit-icon--active');

            setTimeout(function () {
                $('.alert').removeClass('alert--active');
                $('.quick-add-visit-icon').removeClass('quick-add-visit-icon--active');

                //reload page if ending visits
                if (endRoute) {
                    location.reload();
                }
            }, 3500);
        }, 500);
    }

    function completeCallback(route, ids) {
        var signOutErrorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        var table = $('.data-table').DataTable();
        var endRoute = true;

        if (route !== '/visit/end/bulk') {
            endRoute = false;

            for (var i = 0; i < ids.length; i++) {

                var rows = table.rows($('tr[data-visit-id="' + ids[i] + '"')).remove().draw();
            }
        }
        var message = '';

        if (route == '/visit/end/bulk') {
            message = 'Selected Visits have been signed out.';
        } else {
            message = 'Selected Visits have been deleted.';
        }

        if (signOutErrorMessage) {
            message = signOutErrorMessage;
            if ($('.alert').length) {
                removeAlertClasses();
                $('.alert').addClass('alert-error');
                $('.alert').text(message);
            } else {
                var html = '<div class="alert-container"><div class="alert alert-error">' + message + '</div></div>';
                $('body').append(html);
            }
        } else {
            if ($('.alert').length) {
                removeAlertClasses();
                $('.alert').addClass('alert-error');
                $('.alert').text(message);
            } else {
                var html = '<div class="alert-container"><div class="alert alert-success">' + message + '</div></div>';
                $('body').append(html);
            }
        }

        showAlert(endRoute);
    }

    function removeAlertClasses() {
        if ($('.alert').hasClass('alert-error')) {
            $('.alert').removeClass('alert-error');
        }
        if ($('.alert').hasClass('alert-success')) {
            $('.alert').removeClass('alert-success');
        }
    }

    function doAction(route, ids) {

        $.ajax({
            url: window.site.url + route,
            method: 'POST',
            data: {
                ids: ids,
                _token: window.site.token
            },
            success: function success(response) {

                console.log('response: ' + response);
                if (response) {
                    completeCallback(route, ids, response);
                } else {
                    completeCallback(route, ids);
                }

                _modal2.default.closeModal();
                $('.bulk-action').val('null');
                $('.bulk-action-accept').html('Ok');
            },
            complete: function complete(response) {
                // Loop through trs on datatable

                // Remove ids from DOM if in ID list
                // completeCallback(route,ids);


            },
            error: function error(jqXHR, textStatus, errorThrown) {}
        });
    }
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {

	$('.add-input').click(function () {
		var dataInputType = $(this).attr('data-input-type') || 'text';

		addInput($(this).attr('data-target'), $(this).attr('data-type'), $(this).attr('data-plural'), dataInputType);
	});

	$(document).on('click', '.remove-host, .remove-input', function (e) {
		e.preventDefault();
		removeInput(this);
	});

	function removeInput(self) {
		var inputId = $(self).attr('id');
		var plural = $(self).attr('data-plural');
		var parent = $(self).parent();

		//check if this has id ( i.e. exists in database )
		if (inputId.length) {
			//pass id through to server

			//remove input_
			var id = inputId.substr(inputId.indexOf('_') + 1);

			//add deleted input id to hidden fields
			var inputHtml = '<input type="hidden" name="deleted-' + plural + '[]" value="' + id + '">';
			$('.deleted-hosts-container').append(inputHtml);
		}

		parent.hide('slow');
	}

	function addInput(target, type, plural, dataInputType) {
		var html = createNewFieldHtml(type, plural, dataInputType);
		$(target).append(html);
	}

	function createNewFieldHtml(className, plural, dataInputType) {
		var html = '\n            <div class="">\n                <input name="' + className + '-new[]" type="' + dataInputType + '" value="">\n                <a id="" class="remove-host remove-input" data-plural="' + plural + '">Remove</a>\n            </div>';
		return html;
	}
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _modal = __webpack_require__(0);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {

    $(document).on('click', '.delete-guest-btn', function (e) {
        e.preventDefault();

        _modal2.default.openModal('.modal-delete-guest');
    });
});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {

    var $form = $('.box');
    $form.addClass('has-advanced-upload');

    var $input = $form.find('input[type="file"]');

    $form.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
    }).on('dragover dragenter', function () {
        $form.addClass('is-dragover');
    }).on('dragleave dragend drop', function () {
        $form.removeClass('is-dragover');
    }).on('drop', function (e) {
        //console.log(e.originalEvent.dataTransfer.files);
        $("input[type='file']").prop("files", e.originalEvent.dataTransfer.files);
        $form.addClass('has-file-attached');
        $('.file-info').text('File Attached');
    });

    $input.on('change', function (e) {
        $form.addClass('has-file-attached');
        $('.file-info').text('File Attached');
    });
});

/***/ })
/******/ ]);
